import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/** Home page shell; each section is its own component under ./sections. */
@Component({
  selector: 'app-home-five',
  templateUrl: './home-five.component.html',
  styleUrl: './home-five.component.css',
})
export class HomeFiveComponent {
  private readonly translate = inject(TranslateService);

  constructor() {
    inject(ActivatedRoute)
      .params.pipe(takeUntilDestroyed())
      .subscribe((params) => this.translate.use(params['lang'] || 'am'));
  }
}
